import { createBelvdr } from './belvdr.js'

export {
  createBelvdr,
  type Belvdr,
  type BelvdrOptions,
  type StartSessionOptions,
} from './belvdr.js'
export type {
  BeforeSendException,
  BelvdrException,
  BelvdrExceptionFrame,
} from './exception-reporter.js'
export type { MaskNetworkBody, NetworkBodyContext } from './network-body.js'
export type { MaskNetworkUrl } from './network-url.js'
export type { Transport, TransportRequest, TransportResponse } from './transport.js'

/** Instance par défaut : `belvdr.init(…)` dans le script, `import { init } …` via npm. */
const belvdr = createBelvdr()

export const init = belvdr.init
export const startSession = belvdr.startSession
export const stopSession = belvdr.stopSession
export const startErrorTracking = belvdr.startErrorTracking
export const stopErrorTracking = belvdr.stopErrorTracking
export const identify = belvdr.identify
export const reset = belvdr.reset
export const capture = belvdr.capture
export const captureException = belvdr.captureException
